module.exports = "/_next/static/images/video_id_7133331879364676910-cc38d81d5b3f69e9d328125337083ad1.jpg";